import styled, { keyframes } from 'styled-components';

import { Modal, Input, Row, colors, TagGroup } from '@dexma/ui-components';

export const StyledRowContainerRow = styled(Row)`
    margin-top: 1rem;
`;

export const StyledRowMarginTop = styled(Row)`
    margin-top: 0.5rem;
`;

export const StyledRowInlineFlex = styled(Row)`
    display: inline-flex;
`;

export const StyledDashboardLinkModal = styled(Modal)`
    .ant-modal-header {
        border-bottom: none;
    }
    .buttons {
        margin-top: 30px;
        text-align: left;
        .cancel {
            margin-left: 10px;
        }
        // Todo fix on the ui library
        svg,
        .StyledSpinner-iA-dccK {
            border-color: rgb(255 255 255) rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1);
            margin-right: 5px;
        }
    }
    .server-error-alert {
        margin-bottom: 20px;
    }
`;

export const StyledTagGroup = styled(TagGroup)`
    display: inline-block;
`;

type AnimationDiv = {
    $isOpen: boolean;
};

const grow = keyframes`
  0% {
    height: 0px;
  }
  100% {
    height: auto;
  }
`;

export const StyledDivAnimationResetLink = styled.div<AnimationDiv>`
    height: 0px;
    transition: all 0.3s;
    animation: ${(props) => (props.$isOpen ? grow : '')} 300ms ease-in-out forwards;
    opacity: ${(props) => (props.$isOpen ? '1' : '0')};
    visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
`;

export const StyledDivExternalAccess = styled.div`
    display: flex;
    flex-direction: column;
    background: #f1f2f3;
    border-radius: 4px;
    padding: 1rem;
`;

export const StyledSwitchAccess = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 0.5rem;
    padding: 0px;
    gap: 8px;
`;
export const StyledResetLinks = styled.div`
    color: ${colors.red};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 0.5rem;
    gap: 12px;
`;

export const StyledSeparatorLine = styled.hr`
    background-color: ${colors.gray};
`;

export const StyledResetLinksDescription = styled.div`
    color: ${colors.red};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 0.5rem;
    gap: 12px;
`;

export const StyledCopyBody = styled.div`
    display: flex;
`;

export const StyledSpanTitleTooltipReset = styled.span`
    width: 280px;
    line-height: 18px;
    font-size: 12px;
`;

export const StyledSpanTitleTooltipCopy = styled.span`
    line-height: 18px;
    font-size: 12px;
`;

export const StyledSpanFontWeight = styled.span`
    font-size: 12px;
    line-height: 14px;
    font-weight: 600;
`;

export const StyledSpanPointer = styled.span`
    cursor: pointer;
`;

export const StyledDisabledInputLink = styled(Input)`
    text-overflow: ellipsis;
`;
